import { Box, Stack } from '@ltvco/refresh-lib/theme';
import { StyledText } from '@ltvco/refresh-lib/v2';
import { MessageContentRenderer } from './RenderMessageContent';

export interface MessageContentProps {
  content?: string;
  isHeader: boolean;
  isSticky: boolean;
  hasUserScrolled: boolean;
}

export const MessageContent = ({
  content,
  isHeader,
  isSticky,
  hasUserScrolled,
}: MessageContentProps) => (
  <Stack spacing={1}>
    <Box>
      <StyledText
        isHeader={isHeader}
        isSticky={isSticky}
        hasUserScrolled={hasUserScrolled}
        variant={isHeader ? 'h1' : 'body1'}
        fontWeight={isHeader ? 600 : 400}
      >
        <MessageContentRenderer text={content || null} />
      </StyledText>
    </Box>
  </Stack>
);
